(function () {
  if (window.__brandScrollInit) return;
  window.__brandScrollInit = true;

  function headerOffset() {
    var header = document.querySelector('.brand-header');
    var h = header ? header.offsetHeight : 0;
    return h + 16;
  }

  function scrollToSelector(selector) {
    var target;
    try {
      target = document.querySelector(selector);
    } catch (e) {
      return false;
    }
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-scroll-target]');
    if (!trigger) return;
    var selector = trigger.getAttribute('data-scroll-target');
    if (!selector) return;
    var clickable = e.target.closest('a, button');
    if (!clickable || !trigger.contains(clickable)) return;
    if (scrollToSelector(selector)) {
      e.preventDefault();
    }
  });
})();
